import i18next from 'i18next'
import resources from './translation.json'
import Vue from 'vue'
import I18NextVue from 'i18next-vue'

Vue.use(I18NextVue, { i18next })

export default () => {
  const language = document.querySelector('html').getAttribute('lang')

  i18next.init({
    lng: language || 'nl',
    supportedLngs: ['nl', 'en', 'de'],
    fallbackLng: 'nl',
    resources,
    returnEmptyString: false,
    cleanCode: true,
    nonExplicitSupportedLngs: true,
    debug: process.env.NODE_ENV === 'development'
  })
}
